import React from 'react';
import { CircularProgress } from '@mui/material';
import './Loader.css';

export const Loader = () => {
  return (
    <React.Fragment>
      <div className="loading-container" tabIndex="1">
        <div className="loader">
          <CircularProgress sx={{ color: '#FFC107' }} size={60} />
          <p>Loading...</p>
        </div>
      </div>
    </React.Fragment>
  );
};
